var map = {
	"./baguette-cut.svg": 19716,
	"./cushion-cut.svg": 80096,
	"./emerald-cut.svg": 33581,
	"./heart-cut.svg": 59137,
	"./marquise-cut.svg": 49722,
	"./oval-cut.svg": 54393,
	"./pear-cut.svg": 25209,
	"./princess-cut.svg": 59948,
	"./round-cut.svg": 54693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23660;